<template>
  <div>
    <nav-breadcrumb :menu="[{label :'提前还款试算'}]"/>

    <el-row>
      <el-col>
        <panel label="">
          <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
                <el-col :span="12">
                    <el-form-item label="贷款编号："  style="width: 90%">
                        {{dataForm.contractNo}}
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-show="!disabled&&selectBool">
                    <el-form-item label="" style="width: 60%">
                        <el-button type="primary" @click="onSelect()">选择</el-button>
                    </el-form-item>
                </el-col>
              <el-col :span="24">
                <el-form-item label="客户姓名："  style="width: 60%">
                  {{dataForm.customerName}}
                </el-form-item>
              </el-col>


              <el-col :span="24">
                <el-form-item label="提前还款模式：" prop="t__inFull" :rules="{required: true, message: '不能为空'}" style="width: 60%">
                  <el-radio-group v-model="dataForm.t__inFull" :disabled="true" class = "button_radio">
                    <el-radio-button label="Y">全款</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="提前还款日期：" prop="t__repayDate" :rules="{required: true, message: '日期不能为空'}"  label-width="150px">
                  <el-date-picker
                    v-model="dataForm.t__repayDate"
                    value-format="yyyy-MM-dd 00:00:00"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期" :disabled="disabled">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!--<el-col :span="24">
                <el-form-item label="提前还款金额：">
                  <el-input v-model="dataForm.t__totalAmount" :disabled="disabledinFull"></el-input>
                </el-form-item>
              </el-col>-->
            </el-row>
          </el-form>
        </panel>

  <!--      <Panel v-show="this.resolveIds&&!disabled">
          <data-table
            :table-data="tableDataList"
            :columns="columnsList"
            :page.sync="page"
            :pageSize.sync="pageSize"
            :filters.sync="filters"
            :actions="actions"
            :is-pagination-show="false"
          />
        </Panel>-->
        <!--        <div class="cb tr of" style="margin-bottom:8px">
                  <el-button class="tab_close" @click="showPanelChange()" v-show="(dataForm.currents[0]||{}).curr__sequenceNo&&showPanel">收起<i class="el-icon-caret-top
                  el-icon&#45;&#45;right"></i></el-button>
                  <el-button class="tab_open" @click="showPanelChange()" v-show="(dataForm.currents[0]||{}).curr__sequenceNo&&!showPanel">展开<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i></el-button>
                </div>-->
        <el-row :gutter="20" style="margin-bottom: 0px;" v-show="(dataForm.currents[0]||{}).curr__sequenceNo">
          <el-col :span="12"><div class="Htitle-text color-danger">截止提前还款日前该客户要应先偿还以下还款：</div></el-col>
        </el-row>
        <panel :title="'第'+item.curr__sequenceNo+'期（最后还款日：'+ item.curr__expectedRepayDate+'）'" border v-for="(item, idx) in dataForm.currents" :key="idx" v-show="item.curr__sequenceNo&&showPanel">
          <form-build :form-data="item" :form-columns="repayInfoColumns"></form-build>
        </panel>
        <!--          <panel :title="'第'+(dataForm.currents[0]||{}).curr__sequenceNo+'期（最后还款日：'+ (dataForm.currents[0]||{}).curr__expectedRepayDate+'）'" border  v-show="(dataForm.currents[0]||{}).curr__sequenceNo&&!showPanel">
                    <div v-if="(dataForm.currents[0]||{}).needAmount == 0">本期已还清</div>
                    <div v-else>本期还清还需：{{(dataForm.currents[0]||{}).needAmount}}</div>
                    <form-build :form-data="(dataForm.currents[0]||{})" :form-columns="repayInfoColumns"></form-build>
                  </panel>-->
        <!--<Panel v-show="(dataForm.currents[0]||{}).curr__sequenceNo">
          <div class="tr" style="padding-right:15px">本次减免合计：{{freeAmount}}</div>
        </Panel>-->


      <!--  <panel v-show="disabled2">
          <el-row :gutter="20" style="margin-bottom: 0px;">
            <el-col :span="12"><div class="Htitle-text">提前还款试算表</div></el-col>
            <el-col :span="12">
              <div class="tr">
                <el-button class="tab_close" @click="showPanelListChange()" v-show="disabled2&&showPanelList">收起<i class="el-icon-caret-top
   el-icon&#45;&#45;right"></i></el-button>
                <el-button class="tab_open" @click="showPanelListChange()" v-show="disabled2&&!showPanelList">展开<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i></el-button>
              </div>
            </el-col>
          </el-row>
          <data-table v-show="showPanelList"
                      :table-data="tableData"
                      :columns="columns"
                      :page.sync="page"
                      :pageSize.sync="pageSize"
                      :filters.sync="filters"
                      :actions="actions"
                      :is-pagination-show="false"
                      :row-class-name="rowClassName"
          />
          <data-table v-show="!showPanelList"
                      :table-data="tableDataOne"
                      :columns="columns"
                      :page.sync="page"
                      :pageSize.sync="pageSize"
                      :filters.sync="filters"
                      :actions="actions"
                      :is-pagination-show="false"
                      :row-class-name="rowClassName"
          />
        </panel>-->
        <!--<panel  v-show="disabled2&&dataForm.t__excessAmount>0">
          <form-build :form-data="dataForm" :form-columns="dataColumns2" :form-rules="formRules" :form-buttons="formButtons"></form-build>
        </panel>
        <Panel v-show="!(disabled2&&dataForm.t__inFull=='Y'&&dataForm.t__excessAmount>0)&&disabled2">
          <el-button type="primary" @click="print()">导出试算表</el-button>
          <el-button type="primary" @click="onSubmit()">提交申请</el-button>
        </Panel>-->
        <panel v-show="disabled2&&this.dataForm.t__currentApplied=='Y'" border :title="'计息时段('+this.dataForm.t__currentFrDate+'-'+this.dataForm.t__currentToDate+')'">
          <form-build :form-data="dataForm" :form-columns="interestColumns"></form-build>
        </panel>
        <panel v-show="disabled2" style="padding:15px 10px;font-size:14px;">
          <span class="fwb">提前还款总额</span> = {{showformula1}} = <span class="fwb color-danger">{{dataForm.t__totalAmount|formatMoney}}</span>
        </panel>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" v-show="!disabled2">
        <el-button type="primary" @click="next()">下一步</el-button>
      </el-col>
    </el-row>
    <el-dialog
      title="选择"
      :visible.sync="dialogVisible"
      width="100%">
      <data-table
        :table-data="tableDataMatching"
        :columns="columnsMatching"
        :page.sync="pageMatching"
        :pageSize.sync="pageSizeMatching"
        :filters.sync="filtersMatching"
        :actions="actionsMatching"
      />
    </el-dialog>
    <!--<el-dialog
      title="提交申请"
      :visible.sync="dialogVisible2"
      width="30%">
      <form-build :form-data="dataForm" :form-columns="dataColumns"></form-build><br/>
      <data-table
        :table-data="{data:dataForm.currents}"
        :columns="currentsColumns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :is-pagination-show="false"
      /><br/>
      <panel v-show="disabled2&&dataForm.t__excessAmount>0">
        <form-build :form-data="dataForm" :form-columns="dataColumns3"  v-show="dataForm.t__inFull=='Y'"></form-build><br/>
      </panel>
      备注 <el-input type="textarea" v-model="dataForm.t__remarks" style="margin-bottom:10px;"></el-input>
      <el-button type="primary" @click="onSubmitNext()">确认提交</el-button>
    </el-dialog>-->
    <div class="tr xzmt" v-show="disabled2">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import Panel from "../../components/Panel";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "TransferRepaymentEdit",
    components: {Panel},
    data(){

      return {
        interestColumns:[
          {
            label: '剩余本金',
            field: 't__currentPrincipalAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应还利息',
            field: 't__currentInterestAmount',
            formatter: (r,v) => {
              if(this.dataForm.t__inFull=='N')
                return (Number(v)||0).toFixed(2)+"（下期偿还）"
              else
                return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '计息天数',
            field: 't__currentDays',
            formatter: (r,v) => {
              return (Number(v)||0)
            },
            span:24
          },
        ],
        showformula1:'',
        repayAmountInAdvance:null,
        totalAmount:'',
          titlevalue:'提前还款',
        selectBool:true,
        showPanel:true,
        showPanelList:true,
        formRules: {
          t__excessAmountOption: [
            {
              required: true,
              message: '处理方式不能为空不能为空！'
            }
          ]
        },
        formButtons:[
          {
            label: '导出试算表',
            type: 'primary',
            clickHandler: ($refs)=>{
              this.print()
            }
          },
          {
            label: '提交申请',
            type: 'primary',
            clickHandler: ($refs)=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.onSubmit()
                }
              })
            }
          },
        ],
        queryData:this.$route.query['queryData']||'',
        tableDataList:{
          data:[],
          count:0,
        },
        resolveIds :this.$route.query['resolveIds']||null,
        columnsList:[
          {
            label: '银行账户',
            field: 'de__txAccountNo'
          },
          {
            label: '账户名',
            field: 'de__txAccountName'
          },
          {
            label: '转账金额',
            field: 'de__creditAmount'
          },
        ],
        dialogVisible:false,
        dialogVisible2:false,
        disabledinFull:false,
        disabled1:false,
        disabled2:false,
        applicationId:'',
        disabled:false,
        inFull:true,
        tableDataMatching:{
          count: 0,
          data: []
        },
        dataColumns:[
          {
            label: '客户名称',
            field: 'customerName',
            span:24
          },
          {
            label: '罚款合同',
            field: 'contractNo',
            span:24
          },
          {
            label: '提前还款模式',
            field: 't__inFull',
            formatter: function (r,v) {
              if(v=='Y')
                return '全款'
              else
                return '部分'
            },
            span:24
          },
          {
            label: '提前还款日期',
            field: 't__repayDate',
            formatter: function (r,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
              else
                return ''
            },
            span:24
          },
          {
            label: '提前还款金额',
            field: 't__totalAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:24
          },
        ],
        dataColumns2:[
          {
            label: '实收金额',
            field: 't__totalAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:12
          },
          {
            label: '余额',
            field: 't__excessAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:12
          },
          {
            label: '余额处理',
            component: 'el-select',
            field: 't__excessAmountOption',
            options:[
              {
                label:'转入下期',
                value:'None',
              },
              {
                label:'返还客户',
                value:'Refund'
              },
              {
                label:'返还渠道商',
                value:'Refund-ToDealer'
              },
              {
                label:'记入营业外收入',
                value:'Profit',
              }
            ],
            span:12
          },
        ],
        dataColumns3:[
          {
            label: '实收金额',
            field: 't__totalAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:12
          },
          {
            label: '余额',
            field: 't__excessAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:12
          },
          {
            label: '余额处理',
            field: 't__excessAmountOption',
            formatter: (r,v) => {
              return Status2CN(v)
            },
            span:12
          },
        ],
        columnsMatching:[
          {
            type: 'index'
          },
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '客户姓名',
            field: 'c__customerName'
          },
          {
            label: '贷款开始时间',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
              else
                return ''
            }
          },
          {
            label: '贷款结束时间',
            field: 'fi__endDate',
            formatter: (r,c,v) => {
              return moment(v).format('YYYY-MM-DD')
            },
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },
          {
            label: '操作',
            opts:[
              {
                label: '选择',
                class: 'el-icon-finished',
                clickHandler: (index, row)=> {
                  this.Selected(row)
                }
              },
            ]
          }
        ],
        pageMatching: 1,
        pageSizeMatching: 20,
        actionsMatching: [
        ],

        filtersMatching: {
          labelWidth: '150px',
          form: {
            c__customerContactNo:'',
            c__customerName:'',
          },
          columns: [
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'c__customerName'
            },
            {
              label: '手机号',
              component: 'el-input',
              field: 'c__customerContactNo'
            },

          ],
          onSubmit:()=>{
            this.page = 1
            this.onSelect()
          }
        },
        rowClassName: function ({row, idx}) {
          if(row.plan__repaymentStatus=='Settled'){
            return 'bg_color_yhq'
          }else{
            if(row.plan__revisedPrincipalAmount==null){
              return 'bg_color_dclnone'
            }else{
              return 'bg_color_dcl'
            }
          }
        },
        dataForm:{
          t__totalAmount:null,
          t__excessAmount:0,
          customerName:'',
          contractNo:'',
          t__transactionId:'',
          t__repayDate:this.$route.query['txDate']||'',
          t__repayAmountInAdvance:'',
          t__currentApplied:null,
          t__currentDays:null,
          t__currentFrDate:null,
          t__currentToDate:null,
          t__currentPrincipalAmount:null,
          t__currentInterestAmount:null,
          t__exBalanceAmount:null,
          t__inFull:'Y',
          currents:[]
        },
        paramform:{
          't.referenceIdIII':this.resolveIds,
        },
        dataFormRules: {},
        tableData: {
          data:[],
          count:0,
        },
        tableDataOne: {
          data:[],
          count:0,
        },
        dialogVisible: false,
        page: 1,
        pageSize: 20,
        actions: [
        ],
        filters: {
          labelWidth: '150px',
          form: {

          },
          columns: [

          ],
          onSubmit:()=>{
          }
        },
        columns:[
          {
            label: '期数',
            field: 'plan__sequenceNo'
          },
          {
            label: '还款日期',
            field: 'plan__repayDate'
          },
          {
            label: '本金',
            field: 'plan__principalAmount'
          },
          {
            label: '利息',
            field: 'plan__interestAmount'
          },
          {
            label: '还款状态',
            field: 'plan__repaymentStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '试算本金',
            field: 'plan__revisedPrincipalAmount',
            formatter: function (r,c,v) {
              if(r.plan__repaymentStatus=='Settled')
                return '---'
              else
                return formatMoney(v)
            }
          },
          {
            label: '试算利息',
            field: 'plan__revisedInterestAmount',
            formatter: function (r,c,v) {
              if(r.plan__repaymentStatus=='Settled')
                return '---'
              else
                return formatMoney(v)
            }
          },
        ],
        currentsColumns:[
          {
            label: '还款日期',
            field: 'curr__expectedRepayDate'
          },
          {
            label: '应收复利',
            field: 'curr__expectedCompoundInterest',
            formatter: (r,c,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应收罚息',
            field: 'curr__expectedOverdueFine',
            formatter: (r,c,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '减免金额',
            field: 'deductionAmount',
            formatter: (r,c,v) => {
              let deductionAmount = 0
              if(r.curr__waiveOverdueFine=='Y')
                deductionAmount = deductionAmount + parseFloat(r.curr__expectedOverdueFine - r.curr__appliedOverdueFine)
              if(r.curr__waiveCompoundInterest=='Y')
                deductionAmount = deductionAmount + parseFloat(r.curr__expectedCompoundInterest - r.curr__appliedCompoundInterest)
              return deductionAmount.toFixed(2)

            }
          },
        ],
        repayInfoColumns: [
          {
            label: '应还款日',
            field: 'curr__expectedRepayDate',
            span:24
          },
          /*{
            label: '上期余额',
            field: 'curr__exBalanceAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },*/
          {
            label: '应还本金',
            field: 'curr__expectedPrincipalAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            },
            span:24
          },
         /* {
            label: '实收复利',
            field: 'curr__appliedCompoundInterest',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },*/
          {
            label: '应还利息',
            field: 'curr__expectedInterestAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            },
            span:24
          },
          /*{
            label: '实收罚息',
            field: 'curr__appliedOverdueFine',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },*/
          {
            label: '逾期天数',
            field: 'curr__overdueDays',
            span:24
          },
         /* {
            label: '实收利息',
            field: 'curr__appliedInterestAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.curr__expectedInterestAmount">( {{ Number((v- r.curr__expectedInterestAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },*/
          {
            label: '应收复利',
            field: 'curr__expectedCompoundInterest',
            component: (r,v)=> {
              let disabled2 = this.disabled2
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox :disabled="disabled2" type="radio"  v-model="r.curr__waiveCompoundInterest" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled2
                  }
                }
              }
            },
            span:24
          },
          /*{
            label: '实收本金',
            field: 'curr__appliedPrincipalAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.curr__expectedPrincipalAmount">( {{ Number((v- r.curr__expectedPrincipalAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },*/
          {
            label: '应还罚息',
            field: 'curr__expectedOverdueFine',
            component: (r,v)=> {
              let disabled2 = this.disabled2
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled="disabled2"  v-model="r.curr__waiveOverdueFine" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled2
                  }
                }
              }
            },
            span:24
          },
          /* {
             label: '本期余额',
             field: 'curr__excessAmount',
             formatter: (r,v) => {
               return (Number(v)||0).toFixed(2)
             }
           },*/
          {
            label: '应收合计',
            field: 'expectedTotalAmount',
            formatter: (r,v) => {
              return formatMoney(Number(v)||0)
            },
            span: 24
          },
        ],
        repayPlanList: [],
      }
    },
    mounted() {

      if(this.resolveIds){
        this.selectBool =false
        this.getSelect()
        this.getData()
      }else{
        this.titlevalue = '试算'
      }
    },
    computed: {
      watchChecked() {
        return this.dataForm.currents.map(item=>({
          curr__waiveCompoundInterest: item.curr__waiveCompoundInterest,
          curr__waiveOverdueFine: item.curr__waiveOverdueFine
        }))
      },
      /*freeAmount() {
        return (this.dataForm.currents.reduce( (total, item)=> {
          total += item.curr__waiveCompoundInterest == 'Y' ? item.curr__expectedCompoundInterest : 0
          total += item.curr__waiveOverdueFine == 'Y'? item.curr__expectedOverdueFine : 0

          return total;
        }, 0)).toFixed(2)
      }*/
    },
    watch: {
      'dataForm.t__deductionAmount' : function () {
        if(parseFloat(this.dataForm.t__deductionAmount)>parseFloat(this.dataForm.settledInterestAmount)){
          this.$message.error('调整利息不能大于当前利息')
          this.dataForm.t__deductionAmount = 0
        }else{
          this.dataForm.t__totalAmount = this.dataForm.totalAmounts - this.dataForm.t__deductionAmount
        }
      },
      'dataForm.t__totalAmount':function () {
        if(!this.disabled1){
          this.totalAmount = this.dataForm.t__totalAmount
        }
      },
      watchChecked: function () {
        this.calculateDetail()
      }
    },
    created() {
      this.calculateDetail()
    },
    methods:{
      showPanelChange:function(){
        this.showPanel = !this.showPanel
      },
      showPanelListChange:function(){
        this.showPanelList = !this.showPanelList
      },
      getSelect:function(){
        let form = {
          't.inFull':'Y',
          't.referenceIdIII':this.resolveIds,
        }
        xhr.getRevisedRepaymentPlan(
          Object.assign(form, {},{}),
          res=> {
            this.dataForm.customerName =  res.data.data.t__customerName
            this.dataForm.contractNo =  res.data.data.t__transactionNo
            this.dataForm.t__transactionId =  res.data.data .t__transactionId
            this.dataForm.t__totalAmount = res.data.data.t__totalAmount
          })
      },
      getData: function () {
        xhr.getResolvingBankStatementList(
          Object.assign({
            'xlist.search.de.detailId' : this.queryData,
            'xlist.search.de.detailId.op' : 'in',
            pageSize:0
          }, {}, {}),
          res=> {
            try {
              this.tableDataList = res.data

            }catch(e){
              console.log(e)

            }
          })
      },
      calculateDetail() {
        this.dataForm.currents.forEach((item,idx)=> {
          let expectedCompoundInterest = item.curr__waiveCompoundInterest == 'Y' ? 0 :item.curr__expectedCompoundInterest
          let expectedOverdueFine = item.curr__waiveOverdueFine == 'Y'? 0 :item.curr__expectedOverdueFine
          item.expectedTotalAmount =  Number(((parseFloat(item.curr__expectedPrincipalAmount)*100+parseFloat(item.curr__expectedInterestAmount)*100 +parseFloat(expectedCompoundInterest)*100+parseFloat(expectedOverdueFine)*100)/100).toFixed(2))

        })
        this.dataForm = this.dataForm
      },
      onSelect :function () {
        this.dialogVisible = true
        xhr.getProcessingFinancingSelect(
          Object.assign({}, this.filterParamsMatching, xmlBuildQuery(this.filtersMatching)),
          res=> {
            try {
              this.tableDataMatching = res.data
              this.dataForm.customerName = this.tableDataMatching.c__customerName
              this.dataForm.contractNo = this.tableDataMatching.fi__contractNo
            }catch(e){

            }
          })

      },
      Selected:function (row) {
        this.dialogVisible = false
        this.dataForm.customerName = row.c__customerName
        this.dataForm.contractNo = row.fi__contractNo
        this.dataForm.t__transactionId = row.fi__transactionId
        this.filtersMatching.form =  {
          c__customerContactNo:'',
          c__customerName:'',
        }
        this.tableDataMatching= {
          data:[],
          count:0,
        }
      },
      setparamform:function(){

        if(!this.disabled1){
          this.paramform = {
            't.transactionId':this.dataForm.t__transactionId,
            't.repayDate':this.dataForm.t__repayDate,
            't.inFull':this.dataForm.t__inFull,
            't.totalAmount':this.totalAmount+'',
            // 't.deductionAmount':this.dataForm.t__deductionAmount,
            't.referenceIdIII':this.resolveIds,
          }
        }else{
          let excessAmountOption = null
          if(this.dataForm.t__inFull=='Y'){
            excessAmountOption  = this.dataForm.t__excessAmountOption||''
          }
          this.paramform = {
            't.transactionId':this.dataForm.t__transactionId,
            't.repayDate':this.dataForm.t__repayDate,
            't.inFull':this.dataForm.t__inFull,
            't.totalAmount':this.totalAmount+'',
            't.deductionAmount':(this.dataForm.t__deductionAmount||'')+'',
            't.referenceIdIII':this.resolveIds,
            't.excessAmountOption'  : excessAmountOption,
            't.remarks'  : this.dataForm.t__remarks,
            currents:''
          }
          let currents = []
          this.dataForm.currents.forEach(item=>{
            currents.push({
              'curr.checked':item.curr__checked,
              'curr.referenceId':item.curr__referenceId,
              'curr.waiveCompoundInterest':item.curr__waiveCompoundInterest,
              'curr.waiveOverdueFine':item.curr__waiveOverdueFine
            })
          })
          this.paramform.currents = JSON.stringify(currents)
        }
        return this.paramform
      },
      next:function () {

        if(this.dataForm.customerName){
          this.$refs['dataForm'].validate(valid=> {
            if (valid) {

              xhr.getRevisedRepaymentPlan(
                Object.assign(this.setparamform(), {},{}),
                res=> {
                  try {
                    if(res.data.status=='success'){
                      if(this.disabled1){
                        this.disabled2 = true
                        this.dataForm.t__excessAmount = res.data.data.t__excessAmount
                      }else{
                        this.disabled1 = true
                      }
                      if(this.resolveIds==''){
                        this.titlevalue = '试算结果'
                      }
                      const currents = res.data.data.currents
                      currents.forEach(item=>{
                        item.expectedTotalAmount = 0
                      })
                      this.dataForm.currents = currents

                      this.applicationId = res.data.data.t__applicationId
                      this.tableData.data = res.data.data.detail||[]
                      this.tableData.count =  this.tableData.data.length
                      this.tableDataOne.data.push(res.data.data.detail[0]||[])
                      this.tableDataOne.count = 1
                      this.disabled = true
                      this.disabledinFull=true
                      this.dataForm.t__totalAmount = res.data.data.t__totalAmount
                      this.dataForm.t__repayAmountInAdvance = res.data.data.t__repayAmountInAdvance

                      this.dataForm.t__currentApplied = res.data.data.t__currentApplied
                      this.dataForm.t__currentDays = res.data.data.t__currentDays
                      this.dataForm.t__currentFrDate = res.data.data.t__currentFrDate
                      this.dataForm.t__currentToDate = res.data.data.t__currentToDate

                      this.dataForm.t__currentPrincipalAmount = res.data.data.t__currentPrincipalAmount
                      this.dataForm.t__currentInterestAmount = res.data.data.t__currentInterestAmount
                      this.dataForm.t__exBalanceAmount = res.data.data.t__exBalanceAmount
                      this.repayAmountInAdvance = res.data.data.t__repayAmountInAdvance

                      this.showformula1 =formatMoney(this.dataForm.t__currentPrincipalAmount)
                      if(this.dataForm.t__currentInterestAmount>0){
                        this.showformula1 += '+' + formatMoney(this.dataForm.t__currentInterestAmount)
                      }
                      this.dataForm.currents.forEach(item=>{
                        if(item.curr__appliedRepayAmount>0) {
                          this.showformula1 = this.showformula1 + '+' + formatMoney(item.curr__appliedRepayAmount)
                        }
                      })
                      if(this.dataForm.t__exBalanceAmount>0){
                        this.showformula1 = this.showformula1+'-'+formatMoney(this.dataForm.t__exBalanceAmount)+'(上期余额)'
                      }
                      if(res.data.msgs.length>0){
                        let mes = ''
                        res.data.msgs.forEach(item=>{
                          mes = mes +item.text
                        })
                        this.$message.error(mes)
                      }
                    }else{
                      this.$message.error(res.data.msgs[0].text)
                    }

                  }catch(e){
                    console.log(e)
                    this.$message.error(res.data.msgs[0].text)
                  }
                })
            }

          })


        }else{
          this.$message.error("请选择一条合同")
        }

      },
      onSubmit:function () {
        this.dialogVisible2 = true
        this.dataColumns = [
          {
            label: '客户名称',
            field: 'customerName',
            span:24
          },
          {
            label: '罚款合同',
            field: 'contractNo',
            span:24
          },
          {
            label: '提前还款模式',
            field: 't__inFull',
            formatter: function (r,v) {
              if(v=='Y')
                return '全款'
              else
                return '部分'
            },
            span:24
          },
          {
            label: '提前还款日期',
            field: 't__repayDate',
            formatter: function (r,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
              else
                return ''
            },
            span:24
          },
          {
            label: '提前还款金额',
            field: 't__totalAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:24
          },
        ]
        /*if(this.dataForm.t__inFull=='Y'){
          this.dataColumns.push({
            label: '当前月利息调整',
            field: 't__deductionAmount',
            formatter: (r,v) => {
              if(v)
                return formatMoney(v)
              else
                return formatMoney(0)
            },
            span:24
          })
        }*/

      },

      onSubmitNext:function(){
        /* this.dataForm.t__checked = true
         this.dataForm.t__totalAmount = this.dataForm.t__totalAmount +""
         let form = {
           currents:''
         }
         form.t__totalAmount = this.dataForm.t__totalAmount +""
         form.t__transactionId  = this.dataForm.t__transactionId
         form.t__inFull  = this.dataForm.t__inFull
         form.t__remarks  = this.dataForm.t__remarks
         form.t__repayDate  = this.dataForm.t__repayDate
         form.t__referenceIdIII = this.resolveIds
         if(this.dataForm.t__inFull=='Y'){
           form.t__excessAmountOption  = this.dataForm.t__excessAmountOption
           form.t__excessAmount  = this.dataForm.t__excessAmount+""
         }
         let currents = []
         this.dataForm.currents.forEach(item=>{
           currents.push({
             'curr.checked':item.curr__checked,
             'curr.referenceId':item.curr__referenceId,
             'curr.waiveCompoundInterest':item.curr__waiveCompoundInterest,
             'curr.waiveOverdueFine':item.curr__waiveOverdueFine
           })
         })
         form.currents = JSON.stringify(currents)*/
        xhr.updateRevisedRepaymentPlan(
          this.this.setparamform(),
          res=>{
            try {
              if(res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                this.$router.push({
                  path: 'List'
                })
              }
              else {
                this.$message({
                  type: 'error',
                  message: '保存失败！'
                })
              }
            }catch (e) {

            }
          }
        )
      },
      print:function () {
        let form = {
          't.totalAmount':this.dataForm.t__totalAmount +"",
          't.transactionId': this.dataForm.t__transactionId,
          't.repayDate'  : this.dataForm.t__repayDate,
          't.inFull'  : this.dataForm.t__inFull,
          't.referenceIdIII':this.resolveIds,
          currents:'',
        }

        if(this.dataForm.t__inFull=='Y'){
          form.t__excessAmountOption  = this.dataForm.t__excessAmountOption
          form.t__excessAmount  = this.dataForm.t__excessAmount+""
        }
        let currents = []
        this.dataForm.currents.forEach(item=>{
          currents.push({
            'curr.checked':item.curr__checked,
            'curr.referenceId':item.curr__referenceId,
            'curr.waiveCompoundInterest':item.curr__waiveCompoundInterest,
            'curr.waiveOverdueFine':item.curr__waiveOverdueFine
          })
        })
        form.currents = JSON.stringify(currents)
        let routeData = this.$router.resolve({
          path: '/ix/fang/repayment/RevisedRepaymentPlanDetail.List?format=xlsx',
          query: Object.assign(form, {pageSize:0,}, xmlBuildQuery(this.filters))
        });
        window.open(routeData.href.replace('#/', '/'), '_blank');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApplyingRepaymentInAdvanceEdit.vue